import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Typewriter } from 'react-simple-typewriter'
import profile from '../../../../images/Profile/profile.jpg'
import './Banner.css'

const Banner = () => {

    return (
        <div className='text-start   text-white banner d-flex align-items-center justify-content-center my-5'>

            <Container >
                <Row className="g-3">
                    <Col md={6} className='d-flex align-items-center justify-content-center flex-column text-start'>
                        <div>
                            <h6>Hello, I'm</h6>
                            <h1> Zahid Hasan</h1>
                        </div>
                        <br />
                        <h1>  I'm a <span style={{ color: "red" }}>
                            <Typewriter
                                loop
                                cursor
                                cursorStyle="_"
                                typeSpeed={50}
                                deleteSpeed={40}
                                delaySpeed={1000}
                                words={["Web Designer", "Frontend Developer"]}

                            />
                        </span>
                        </h1>


                        <Button href="./Md Zahid Hasan_resume 2023.pdf" download style={{ backgroundColor: "#341f97" }}>
                            Download Resume
                        </Button>
                    </Col>
                    <Col md={5} className='text-end p-3'>
                        <img className='img-fluid rounded-circle ' src={profile} alt="" style={{ height: '300px', width: "300px" }} />
                    </Col>
                </Row>


            </Container>
        </div>
    );
};

export default Banner;